module.exports = __webpack_public_path__ + "img/accessories.758dd219.svg";